// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 21/08/2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import EndOfDayActionTypes from './end-of-day.types';
import {
	allCollectionDetailsGet,
	BranchEODWalletDetailsGet,
	BranchEODThriftDetailsGet,
	BranchEODSavingsDetailsGet,
	BranchEODYetToCollectArrearDetailsGet,
	DemandCollectionTotalDetailsGet,
	AdvanceCollectionTotalDetailsGet,
	ArrearCollectionTotalDetailsGet,
	WalletCollectionTotalDetailsGet,
	PrecloseCollectionTotalDetailsGet,
	LoanAdvanceUsedTotalDetailsGet,
	CloseLoanListDetailsGet,
	BranchEODDetailsGet,
	accountDayBookReportGet,
	PrecloseCollectionDetailsGet,
	AdvanceCollectionDetailsGet,
	ArrearCollectionDetailsGet,
	VoucherApprovedDetailsGet,
	SubmitEODDetailsGet,
	RevertEODDetailsGet,
	EODSavingsCollectionDetailsGet,
	EODGoldCollectionDetailsGet,
	EODStaffTravelDetailsGet,
	SubmitEODStaffTravelDetailsPost,
} from './end-of-day.service';
import {
	getAllCollectionDetailsSuccess,
	getAllCollectionDetailsFailure,
	getAllCollectionDetailsResponseChanged,
	getBranchEODWalletDetailsSuccess,
	getBranchEODWalletDetailsFailure,
	getBranchEODWalletDetailsResponseChanged,
	getBranchEODThriftDetailsSuccess,
	getBranchEODThriftDetailsFailure,
	getBranchEODThriftDetailsResponseChanged,
	getBranchEODSavingsDetailsSuccess,
	getBranchEODSavingsDetailsFailure,
	getBranchEODSavingsDetailsResponseChanged,
	getBranchEODYetToCollectArrearDetailsSuccess,
	getBranchEODYetToCollectArrearDetailsFailure,
	getBranchEODYetToCollectArrearDetailsResponseChanged,
	getDemandCollectionTotalDetailsSuccess,
	getDemandCollectionTotalDetailsFailure,
	getDemandCollectionTotalDetailsResponseChanged,
	getAdvanceCollectionTotalDetailsSuccess,
	getAdvanceCollectionTotalDetailsFailure,
	getAdvanceCollectionTotalDetailsResponseChanged,
	getArrearCollectionTotalDetailsSuccess,
	getArrearCollectionTotalDetailsFailure,
	getArrearCollectionTotalDetailsResponseChanged,
	getWalletCollectionTotalDetailsSuccess,
	getWalletCollectionTotalDetailsFailure,
	getWalletCollectionTotalDetailsResponseChanged,
	getPrecloseCollectionTotalDetailsSuccess,
	getPrecloseCollectionTotalDetailsFailure,
	getPrecloseCollectionTotalDetailsResponseChanged,
	getLoanAdvanceUsedTotalDetailsSuccess,
	getLoanAdvanceUsedTotalDetailsFailure,
	getLoanAdvanceUsedTotalDetailsResponseChanged,
	getCloseLoanListDetailsSuccess,
	getCloseLoanListDetailsFailure,
	getCloseLoanListDetailsResponseChanged,
	getBranchEODDetailsSuccess,
	getBranchEODDetailsFailure,
	getBranchEODDetailsResponseChanged,
	getPreviousDayBankAccountDayBookReportSuccess,
	getPreviousDayBankAccountDayBookReportFailure,
	getPreviousDayBankAccountDayBookReportResponseChanged,
	fetchBankAccountDayBookReportSuccess,
	fetchBankAccountDayBookReportFailure,
	fetchBankAccountDayBookReportResponseChanged,
	getPreviousDayCashAccountDayBookReportSuccess,
	getPreviousDayCashAccountDayBookReportFailure,
	getPreviousDayCashAccountDayBookReportResponseChanged,
	getCashAccountDayBookReportSuccess,
	getCashAccountDayBookReportFailure,
	getCashAccountDayBookReportResponseChanged,
	getPrecloseCollectionDetailsSuccess,
	getPrecloseCollectionDetailsFailure,
	getPrecloseCollectionDetailsResponseChanged,
	getAdvanceCollectionDetailsSuccess,
	getAdvanceCollectionDetailsFailure,
	getAdvanceCollectionDetailsResponseChanged,
	getArrearCollectionDetailsSuccess,
	getArrearCollectionDetailsFailure,
	getArrearCollectionDetailsResponseChanged,
	getVoucherApprovedDetailsSuccess,
	getVoucherApprovedDetailsFailure,
	getVoucherApprovedDetailsResponseChanged,
	getSubmitEODDetailsSuccess,
	getSubmitEODDetailsFailure,
	getSubmitEODDetailsResponseChanged,
	getRevertEODDetailsSuccess,
	getRevertEODDetailsFailure,
	getRevertEODDetailsResponseChanged,
	fetchAccountDayBookReportFailure,
	fetchAccountDayBookReportSuccess,
	fetchAccountDayBookReportResponseChanged,
	getEODSavingsCollectionDetailsSuccess,
	getEODSavingsCollectionDetailsFailure,
	getEODSavingsCollectionDetailsResponseChanged,
	getEODGoldCollectionDetailsSuccess,
	getEODGoldCollectionDetailsFailure,
	getEODGoldCollectionDetailsResponseChanged,
	getEODStaffTravelDetailsFailure,
	getEODStaffTravelDetailsSuccess,
	getEODStaffTravelDetailsResponseChanged,
	submitEODStaffTravelDetailsSuccess,
	submitEODStaffTravelDetailsFailure,
	submitEODStaffTravelDetailsResponseChanged,
} from './end-of-day.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET ALL COLLECTION DETAILS  ******************** */
export function* getAllCollectionList({ payload }: any) {
	try {
		const key = 'GetAllCollectionDetailsKey';
		const { companyID, branchID, databaseName, eodDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			FromDate: eodDate,
			ToDate: eodDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allCollectionDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getAllCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllCollectionDetailsFailure(error));
	}
}

export function* resetAllCollectionDetailsResponse() {
	yield put(getAllCollectionDetailsResponseChanged());
}

export function* onGetAllCollectionDetails() {
	yield takeLatest(EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_START, getAllCollectionList);
}

export function* onGetAllCollectionDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ALL_COLLECTION_DETAILS_RESPONSE_RESET,
		resetAllCollectionDetailsResponse,
	);
}
/** *********************  END GET ALL COLLECTION DETAILS ******************** */

/** *********************  START GET BRANCH EOD WALLET DETAILS  ******************** */
export function* getBranchEODWalletList({ payload }: any) {
	try {
		const key = 'GetEODWalletAmountDetailsKey';
		const { companyID, branchID, databaseName, inputDate, selectLoanTab } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: inputDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(BranchEODWalletDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchEODWalletDetailsFailure(responseData.data));
		} else {
			yield put(getBranchEODWalletDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchEODWalletDetailsFailure(error));
	}
}

export function* resetBranchEODWalletDetailsResponse() {
	yield put(getBranchEODWalletDetailsResponseChanged());
}

export function* onGetBranchEODWalletDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_START,
		getBranchEODWalletList,
	);
}

export function* onGetBranchEODWalletDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_WALLET_DETAILS_RESPONSE_RESET,
		resetBranchEODWalletDetailsResponse,
	);
}
/** *********************  END GET ALL COLLECTION DETAILS ******************** */

/** *********************  START GET BRANCH EOD THRIFT DETAILS  ******************** */
export function* getBranchEODThriftList({ payload }: any) {
	try {
		const key = 'GetBranchEODThriftDetailsKey';
		const { companyID, branchID, databaseName, fromDate, toDate, userID, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			UserID: userID,
			UserLevel: payload.UserLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(BranchEODThriftDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchEODThriftDetailsFailure(responseData.data));
		} else {
			yield put(getBranchEODThriftDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchEODThriftDetailsFailure(error));
	}
}

export function* resetBranchEODThriftDetailsResponse() {
	yield put(getBranchEODThriftDetailsResponseChanged());
}

export function* onGetBranchEODThriftDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_START,
		getBranchEODThriftList,
	);
}

export function* onGetBranchEODThriftDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_THRIFT_DETAILS_RESPONSE_RESET,
		resetBranchEODThriftDetailsResponse,
	);
}
/** *********************  END GET ALL COLLECTION DETAILS ******************** */

/** *********************  START GET BRANCH EOD SAVINGS DETAILS  ******************** */
export function* getBranchEODSavingsList({ payload }: any) {
	try {
		const key = 'GetBranchEODSavingsDetailsKey';
		const {
			companyID,
			branchID,
			databaseName,
			fromDate,
			toDate,
			userID,
			userLevel,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(BranchEODSavingsDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchEODSavingsDetailsFailure(responseData.data));
		} else {
			yield put(getBranchEODSavingsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchEODSavingsDetailsFailure(error));
	}
}

export function* resetBranchEODSavingsDetailsResponse() {
	yield put(getBranchEODSavingsDetailsResponseChanged());
}

export function* onGetBranchEODSavingsDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_START,
		getBranchEODSavingsList,
	);
}

export function* onGetBranchEODSavingsDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_SAVINGS_DETAILS_RESPONSE_RESET,
		resetBranchEODSavingsDetailsResponse,
	);
}
/** *********************  END GET ALL COLLECTION DETAILS ******************** */

/** **************  START GET BRANCH EOD YETTOCOLLECT ARREAR DETAILS  **************** */
export function* getBranchEODYetToCollectArrearList({ payload }: any) {
	try {
		const key = 'GetBranchEODYetToCollectArrearDetailsKey';
		const { companyID, branchID, databaseName, fromDate, selectLoanTab } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			DemandDate: fromDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(BranchEODYetToCollectArrearDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchEODYetToCollectArrearDetailsFailure(responseData.data));
		} else {
			yield put(getBranchEODYetToCollectArrearDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchEODYetToCollectArrearDetailsFailure(error));
	}
}

export function* resetBranchEODYetToCollectArrearDetailsResponse() {
	yield put(getBranchEODYetToCollectArrearDetailsResponseChanged());
}

export function* onGetBranchEODYetToCollectArrearDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_START,
		getBranchEODYetToCollectArrearList,
	);
}

export function* onGetBranchEODYetToCollectArrearDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_YETTOCOLLECT_ARREAR_DETAILS_RESPONSE_RESET,
		resetBranchEODYetToCollectArrearDetailsResponse,
	);
}
/** *********************  END GET ALL YETTOCOLLECT ARREAR DETAILS ******************** */

/** *********************  START GET DEMAND COLLECTION TOTAL DETAILS  ******************** */
export function* getDemandCollectionTotalList({ payload }: any) {
	try {
		const key = 'GetDemandCollectionTotalDetailsKey';
		const { companyID, branchID, databaseName, eodDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			EODDate: eodDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(DemandCollectionTotalDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDemandCollectionTotalDetailsFailure(responseData.data));
		} else {
			yield put(getDemandCollectionTotalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDemandCollectionTotalDetailsFailure(error));
	}
}

export function* resetDemandCollectionTotalDetailsResponse() {
	yield put(getDemandCollectionTotalDetailsResponseChanged());
}

export function* onGetDemandCollectionTotalDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_START,
		getDemandCollectionTotalList,
	);
}

export function* onGetDemandCollectionTotalDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_DEMAND_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
		resetDemandCollectionTotalDetailsResponse,
	);
}
/** *********************  END GET DEMAND COLLECTION TOTAL DETAILS ******************** */

/** *********************  START GET ADVANCE COLLECTION TOTAL DETAILS  ******************** */
export function* getAdvanceCollectionTotalList({ payload }: any) {
	try {
		const key = 'GetAdvanceCollectionTotalDetailsKey';
		const { companyID, branchID, databaseName, fromDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			EODDate: fromDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(AdvanceCollectionTotalDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAdvanceCollectionTotalDetailsFailure(responseData.data));
		} else {
			yield put(getAdvanceCollectionTotalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAdvanceCollectionTotalDetailsFailure(error));
	}
}

export function* resetAdvanceCollectionTotalDetailsResponse() {
	yield put(getAdvanceCollectionTotalDetailsResponseChanged());
}

export function* onGetAdvanceCollectionTotalDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_START,
		getAdvanceCollectionTotalList,
	);
}

export function* onGetAdvanceCollectionTotalDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ADVANCE_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
		resetAdvanceCollectionTotalDetailsResponse,
	);
}
/** *********************  END GET ADVANCE COLLECTION TOTAL DETAILS ******************** */

/** *********************  START GET ARREAR COLLECTION TOTAL DETAILS  ******************** */
export function* getArrearCollectionTotalList({ payload }: any) {
	try {
		const key = 'GetArrearCollectionTotalDetailsKey';
		const { companyID, branchID, databaseName, fromDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			EODDate: fromDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ArrearCollectionTotalDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getArrearCollectionTotalDetailsFailure(responseData.data));
		} else {
			yield put(getArrearCollectionTotalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getArrearCollectionTotalDetailsFailure(error));
	}
}

export function* resetArrearCollectionTotalDetailsResponse() {
	yield put(getArrearCollectionTotalDetailsResponseChanged());
}

export function* onGetArrearCollectionTotalDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_START,
		getArrearCollectionTotalList,
	);
}

export function* onGetArrearCollectionTotalDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ARREAR_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
		resetArrearCollectionTotalDetailsResponse,
	);
}
/** *********************  END GET ARREAR COLLECTION TOTAL DETAILS ******************** */

/** *********************  START GET WALLET COLLECTION TOTAL DETAILS  ******************** */
export function* getWalletCollectionTotalList({ payload }: any) {
	try {
		const key = 'GetWalletCollectionTotalDetailsKey';
		const { companyID, branchID, databaseName, fromDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			EODDate: fromDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(WalletCollectionTotalDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getWalletCollectionTotalDetailsFailure(responseData.data));
		} else {
			yield put(getWalletCollectionTotalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getWalletCollectionTotalDetailsFailure(error));
	}
}

export function* resetWalletCollectionTotalDetailsResponse() {
	yield put(getWalletCollectionTotalDetailsResponseChanged());
}

export function* onGetWalletCollectionTotalDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_START,
		getWalletCollectionTotalList,
	);
}

export function* onGetWalletCollectionTotalDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_WALLET_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
		resetWalletCollectionTotalDetailsResponse,
	);
}
/** *********************  END GET WALLET COLLECTION TOTAL DETAILS ******************** */

/** *********************  START GET PRECLOSE COLLECTION TOTAL DETAILS  ******************** */
export function* getPrecloseCollectionTotalList({ payload }: any) {
	try {
		const key = 'GetPrecloseCollectionTotalDetailsKey';
		const { companyID, branchID, databaseName, fromDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			EODDate: fromDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PrecloseCollectionTotalDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPrecloseCollectionTotalDetailsFailure(responseData.data));
		} else {
			yield put(getPrecloseCollectionTotalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPrecloseCollectionTotalDetailsFailure(error));
	}
}

export function* resetPrecloseCollectionTotalDetailsResponse() {
	yield put(getPrecloseCollectionTotalDetailsResponseChanged());
}

export function* onGetPrecloseCollectionTotalDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_START,
		getPrecloseCollectionTotalList,
	);
}

export function* onGetPrecloseCollectionTotalDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_TOTAL_DETAILS_RESPONSE_RESET,
		resetPrecloseCollectionTotalDetailsResponse,
	);
}
/** *********************  END GET PRECLOSE COLLECTION TOTAL DETAILS ******************** */

/** *********************  START GET LOAN ADVANCE USED TOTAL DETAILS  ******************** */
export function* getLoanAdvanceUsedTotalList({ payload }: any) {
	try {
		const key = 'GetLoanAdvanceUsedTotalDetailsKey';
		const { companyID, branchID, databaseName, fromDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			EODDate: fromDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(LoanAdvanceUsedTotalDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanAdvanceUsedTotalDetailsFailure(responseData.data));
		} else {
			yield put(getLoanAdvanceUsedTotalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanAdvanceUsedTotalDetailsFailure(error));
	}
}

export function* resetLoanAdvanceUsedTotalDetailsResponse() {
	yield put(getLoanAdvanceUsedTotalDetailsResponseChanged());
}

export function* onGetLoanAdvanceUsedTotalDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_START,
		getLoanAdvanceUsedTotalList,
	);
}

export function* onGetLoanAdvanceUsedTotalDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_LOAN_ADVANCE_USED_TOTAL_DETAILS_RESPONSE_RESET,
		resetLoanAdvanceUsedTotalDetailsResponse,
	);
}
/** *********************  END GET PRECLOSE COLLECTION TOTAL DETAILS ******************** */

/** *********************  START GET CLOSE LOAN LIST DETAILS  ******************** */
export function* getCloseLoanDetailsList({ payload }: any) {
	try {
		const key = 'CloseLoanListFetchKey';
		const { companyID, branchID, databaseName, fromDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			RePayDate: fromDate,
			UserID: userID,
			UserLevel: userLevel,
			CollectionMode: 'closeLoans',
			OfficerID: 0,
			CenterID: 'All',
			LoanType: 'MFI',
			LoanIndexType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(CloseLoanListDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCloseLoanListDetailsFailure(responseData.data));
		} else {
			yield put(getCloseLoanListDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCloseLoanListDetailsFailure(error));
	}
}

export function* resetCloseLoanListDetailsResponse() {
	yield put(getCloseLoanListDetailsResponseChanged());
}

export function* onGetCloseLoanListDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_START,
		getCloseLoanDetailsList,
	);
}

export function* onGetCloseLoanListDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_CLOSE_LOAN_LIST_DETAILS_RESPONSE_RESET,
		resetCloseLoanListDetailsResponse,
	);
}
/** *********************  END GET CLOSE LOAN LIST DETAILS ******************** */

/** *********************  START GET BRANCH EOD DETAILS  ******************** */
export function* getBranchEODDetailsList({ payload }: any) {
	try {
		const key = 'GetBranchEODDetailsKey';
		const { companyID, branchID, databaseName, fromDate, userID, userLevel, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: fromDate,
			UserID: userID,
			UserLevel: userLevel,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(BranchEODDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchEODDetailsFailure(responseData.data));
		} else {
			yield put(getBranchEODDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchEODDetailsFailure(error));
	}
}

export function* resetBranchEODDetailsResponse() {
	yield put(getBranchEODDetailsResponseChanged());
}

export function* onGetBranchEODDetails() {
	yield takeLatest(EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_START, getBranchEODDetailsList);
}

export function* onGetBranchEODDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BRANCH_EOD_DETAILS_RESPONSE_RESET,
		resetBranchEODDetailsResponse,
	);
}
/** *********************  END GET CLOSE LOAN LIST DETAILS ******************** */

/** *********************  START GET BANK ACCOUNT DAY BOOK DETAILS  ******************** */
export function* getBankAccountDayBookReport({ payload }: any) {
	try {
		const key = 'FetchBranchAccountDetailsKey';
		const {
			companyID,
			branchID,
			databaseName,
			fromDate,
			toDate,
			accountHeadID,
			accountType,
			searchbyDateType,
			entryDate,
			infogCompanyID,
			requestCallType,
			selectLoanTab,
		} = payload;
		const jsonData = {
			EntryDate: entryDate,
			FromDate: fromDate,
			ToDate: toDate,
			AccountHeadID: accountHeadID,
			Infog_CompanyID: infogCompanyID,
			AccountType: accountType,
			CompanyID: companyID,
			DatabaseName: databaseName,
			SearchbyDateType: searchbyDateType,
			BranchID: branchID,
			RequestCallType: requestCallType,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountDayBookReportGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBankAccountDayBookReportFailure(responseData.data));
		} else {
			yield put(fetchBankAccountDayBookReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBankAccountDayBookReportFailure(error));
	}
}
export function* resetGetBankAccountDayBookReportListResponse() {
	yield put(fetchBankAccountDayBookReportResponseChanged());
}
export function* onGetBankAccountDayBookReportDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_START,
		getBankAccountDayBookReport,
	);
}
export function* onGetBankAccountDayBookReportResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
		resetGetBankAccountDayBookReportListResponse,
	);
}
/** *********************  END GET BANK ACCOUNT DAY BOOK DETAILS ******************** */

/** *********************  START PREVIOUS DAY BANK ACCOUNT DAY BOOK DETAILS  ******************** */
export function* getPreviousDayBankAccountDayBookReport({ payload }: any) {
	try {
		const key = 'FetchBranchAccountDetailsKey';
		const {
			companyID,
			branchID,
			databaseName,
			fromDate,
			toDate,
			accountHeadID,
			accountType,
			searchbyDateType,
			entryDate,
			infogCompanyID,
			requestCallType,
			selectLoanTab,
		} = payload;
		const jsonData = {
			EntryDate: entryDate,
			FromDate: fromDate,
			ToDate: toDate,
			AccountHeadID: accountHeadID,
			Infog_CompanyID: infogCompanyID,
			AccountType: accountType,
			CompanyID: companyID,
			DatabaseName: databaseName,
			SearchbyDateType: searchbyDateType,
			BranchID: branchID,
			RequestCallType: requestCallType,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountDayBookReportGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPreviousDayBankAccountDayBookReportFailure(responseData.data));
		} else {
			yield put(getPreviousDayBankAccountDayBookReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPreviousDayBankAccountDayBookReportFailure(error));
	}
}

export function* resetGetPreviousDayBankAccountDayBookReportListResponse() {
	yield put(getPreviousDayBankAccountDayBookReportResponseChanged());
}

export function* onGetPreviousDayBankAccountDayBookReportDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_START,
		getPreviousDayBankAccountDayBookReport,
	);
}

export function* onGetPreviousDayBankAccountDayBookReportResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_PREVIOUS_DAY_BANK_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
		resetGetPreviousDayBankAccountDayBookReportListResponse,
	);
}
/** *********************  END GET PREVIOUS DAY BANK ACCOUNT DAY BOOK DETAILS ******************** */

/** *********************  START GET MONTHLY PROGRESS DETAILS  ******************** */
export function* getAccountDayBookReport({ payload }: any) {
	try {
		const key = 'FetchBranchAccountDetailsKey';
		const {
			entryDate,
			fromDate,
			toDate,
			accountHeadID,
			infogCompanyID,
			accountType,
			companyID,
			databaseName,
			searchbyDateType,
			branchID,
			requestCallType,
			selectLoanTab,
		} = payload;
		const jsonData = {
			EntryDate: entryDate,
			FromDate: fromDate,
			ToDate: toDate,
			AccountHeadID: accountHeadID,
			Infog_CompanyID: infogCompanyID,
			AccountType: accountType,
			CompanyID: companyID,
			DatabaseName: databaseName,
			SearchbyDateType: searchbyDateType,
			BranchID: branchID,
			RequestCallType: requestCallType,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountDayBookReportGet, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAccountDayBookReportFailure(responseData.data));
		} else {
			yield put(fetchAccountDayBookReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAccountDayBookReportFailure(error));
	}
}

export function* resetGetAccountDayBookReportListResponse() {
	yield put(fetchAccountDayBookReportResponseChanged());
}

export function* onGetAccountDayBookReportDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_START,
		getAccountDayBookReport,
	);
}

export function* onGetAccountDayBookReportResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
		resetGetAccountDayBookReportListResponse,
	);
}
/** *********************  END GET MONTHLY PROGRESS LIST ******************** */

/** *********************  START PREVIOUS DAY CASH ACCOUNT DAY BOOK DETAILS  ******************** */
export function* getPreviousDayCashAccountDayBookReport({ payload }: any) {
	try {
		const key = 'FetchBranchAccountDetailsKey';
		const {
			companyID,
			branchID,
			databaseName,
			fromDate,
			toDate,
			accountHeadID,
			accountType,
			searchbyDateType,
			entryDate,
			requestCallType,
			infogCompanyID,
			selectLoanTab,
		} = payload;
		const jsonData = {
			EntryDate: entryDate,
			FromDate: fromDate,
			ToDate: toDate,
			AccountHeadID: accountHeadID,
			Infog_CompanyID: infogCompanyID,
			AccountType: accountType,
			CompanyID: companyID,
			DatabaseName: databaseName,
			SearchbyDateType: searchbyDateType,
			BranchID: branchID,
			RequestCallType: requestCallType,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountDayBookReportGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPreviousDayCashAccountDayBookReportFailure(responseData.data));
		} else {
			yield put(getPreviousDayCashAccountDayBookReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPreviousDayCashAccountDayBookReportFailure(error));
	}
}

export function* resetGetPreviousDayCashAccountDayBookReportListResponse() {
	yield put(getPreviousDayCashAccountDayBookReportResponseChanged());
}

export function* onGetPreviousDayCashAccountDayBookReportDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_START,
		getPreviousDayCashAccountDayBookReport,
	);
}

export function* onGetPreviousDayCashAccountDayBookReportResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_PREVIOUS_DAY_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
		resetGetPreviousDayCashAccountDayBookReportListResponse,
	);
}
/** *********************  END GET PREVIOUS DAY CASH ACCOUNT DAY BOOK DETAILS ******************** */

/** *********************  START CASH ACCOUNT DAY BOOK DETAILS  ******************** */
export function* getCashAccountDayBookReport({ payload }: any) {
	try {
		const key = 'FetchBranchAccountDetailsKey';
		const {
			companyID,
			branchID,
			databaseName,
			fromDate,
			toDate,
			accountHeadID,
			accountType,
			searchbyDateType,
			entryDate,
			infogCompanyID,
			requestCallType,
			selectLoanTab,
		} = payload;
		const jsonData = {
			EntryDate: entryDate,
			FromDate: fromDate,
			ToDate: toDate,
			AccountHeadID: accountHeadID,
			Infog_CompanyID: infogCompanyID,
			AccountType: accountType,
			CompanyID: companyID,
			DatabaseName: databaseName,
			SearchbyDateType: searchbyDateType,
			BranchID: branchID,
			RequestCallType: requestCallType,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountDayBookReportGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCashAccountDayBookReportFailure(responseData.data));
		} else {
			yield put(getCashAccountDayBookReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCashAccountDayBookReportFailure(error));
	}
}

export function* resetGetCashAccountDayBookReportListResponse() {
	yield put(getCashAccountDayBookReportResponseChanged());
}

export function* onGetCashAccountDayBookReportDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_START,
		getCashAccountDayBookReport,
	);
}

export function* onGetCashAccountDayBookReportResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_CASH_ACCOUNT_DAY_BOOK_REPORT_RESPONSE_RESET,
		resetGetCashAccountDayBookReportListResponse,
	);
}
/** *********************  END GET CASH ACCOUNT DAY BOOK DETAILS ******************** */

/** *********************  START GET PRECLOSE COLLECTION DETAILS  ******************** */
export function* getPrecloseCollectionList({ payload }: any) {
	try {
		const key = 'GetPrecloseCollectionDetailsKey';
		const { companyID, branchID, databaseName, inputDate, selectLoanTab } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: inputDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PrecloseCollectionDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPrecloseCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getPrecloseCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPrecloseCollectionDetailsFailure(error));
	}
}

export function* resetPrecloseCollectionDetailsResponse() {
	yield put(getPrecloseCollectionDetailsResponseChanged());
}

export function* onGetPrecloseCollectionDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_START,
		getPrecloseCollectionList,
	);
}

export function* onGetPrecloseCollectionDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_PRECLOSE_COLLECTION_DETAILS_RESPONSE_RESET,
		resetPrecloseCollectionDetailsResponse,
	);
}
/** *********************  END GET PRECLOSE COLLECTION DETAILS ******************** */

/** *********************  START GET ADVANCE COLLECTION DETAILS  ******************** */
export function* getAdvanceCollectionList({ payload }: any) {
	try {
		const key = 'GetAdvanceCollectionDetailsKey';
		const { companyID, branchID, databaseName, eodDate, selectLoanTab } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: eodDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(AdvanceCollectionDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAdvanceCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getAdvanceCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAdvanceCollectionDetailsFailure(error));
	}
}

export function* resetAdvanceCollectionDetailsResponse() {
	yield put(getAdvanceCollectionDetailsResponseChanged());
}

export function* onGetAdvanceCollectionDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_START,
		getAdvanceCollectionList,
	);
}

export function* onGetAdvanceCollectionDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ADVANCE_COLLECTION_DETAILS_RESPONSE_RESET,
		resetAdvanceCollectionDetailsResponse,
	);
}
/** *********************  END GET ADVANCE COLLECTION DETAILS ******************** */

/** *********************  START GET ARREAR COLLECTION DETAILS  ******************** */
export function* getArrearCollectionList({ payload }: any) {
	try {
		const key = 'GetArrearCollectionDetailsKey';
		const { companyID, branchID, databaseName, inputDate, selectLoanTab } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: inputDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ArrearCollectionDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getArrearCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getArrearCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getArrearCollectionDetailsFailure(error));
	}
}

export function* resetArrearCollectionDetailsResponse() {
	yield put(getArrearCollectionDetailsResponseChanged());
}

export function* onGetArrearCollectionDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_START,
		getArrearCollectionList,
	);
}

export function* onGetArrearCollectionDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_ARREAR_COLLECTION_DETAILS_RESPONSE_RESET,
		resetArrearCollectionDetailsResponse,
	);
}
/** *********************  END GET ARREAR COLLECTION DETAILS ******************** */

/** *********************  START GET VOUCHER APPROVED DETAILS  ******************** */
export function* getVoucherApprovedList({ payload }: any) {
	try {
		const key = 'GetVoucherApprovedDetailsKey';
		const { companyID, branchID, databaseName, inputDate, infogCompanyID, selectLoanTab } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: inputDate,
			Infog_CompanyID: infogCompanyID,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(VoucherApprovedDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getVoucherApprovedDetailsFailure(responseData.data));
		} else {
			yield put(getVoucherApprovedDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getVoucherApprovedDetailsFailure(error));
	}
}

export function* resetVoucherApprovedDetailsResponse() {
	yield put(getVoucherApprovedDetailsResponseChanged());
}

export function* onGetVoucherApprovedDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_START,
		getVoucherApprovedList,
	);
}

export function* onGetVoucherApprovedDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_VOUCHER_APPROVED_DETAILS_RESPONSE_RESET,
		resetVoucherApprovedDetailsResponse,
	);
}
/** *********************  END GET VOUCHER APPROVED DETAILS ******************** */

/** *********************  START GET EOD SUBMIT DETAILS  ******************** */
export function* getSubmitEODList({ payload }: any) {
	try {
		const key = 'GetSubmitEODDetailsKey';
		const {
			databaseName,
			companyID,
			branchID,
			inputDate,
			userID,
			userLevel,
			holidayDate,
			twoThousandValue,
			fiveHundredValue,
			twoHundredValue,
			hundredValue,
			fiftyValue,
			twentyValue,
			tenValue,
			fiveValue,
			twoValue,
			oneValue,
			totalDenominationAmount,
			userName,
			branchName,
			branchCashAccountID,
			branchBankAccountID,
			branchBankClosingBalance,
			closingBalanceIsDrCr,
			isAutoEODNeeded,
			isAutoEODNeededSat,
			infogCompanyID,
			bankClosingBalanceIsDrCr,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DataBaseName: databaseName,
			BranchID: branchID,
			InputDate: inputDate,
			UserID: userID,
			CreatedBy: userID,
			UserLevel: userLevel,
			HolidayDate: holidayDate,
			TwoThousandValue: twoThousandValue,
			FiveHundredValue: fiveHundredValue,
			TwoHundredValue: twoHundredValue,
			HundredValue: hundredValue,
			FiftyValue: fiftyValue,
			TwentyValue: twentyValue,
			TenValue: tenValue,
			FiveValue: fiveValue,
			TwoValue: twoValue,
			OneValue: oneValue,
			TotalDenominationAmount: totalDenominationAmount,
			UserName: userName,
			BranchName: branchName,
			BranchCashAccountID: branchCashAccountID,
			BranchBankAccountID: branchBankAccountID,
			BranchBankClosingBalance: branchBankClosingBalance,
			ClosingBalanceIsDrCr: closingBalanceIsDrCr,
			IsAutoEODNeeded: isAutoEODNeeded,
			IsAutoEODNeededSat: isAutoEODNeededSat,
			InfogID: infogCompanyID,
			BankClosingBalanceIsDrCr: bankClosingBalanceIsDrCr,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(SubmitEODDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSubmitEODDetailsFailure(responseData.data));
		} else {
			yield put(getSubmitEODDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSubmitEODDetailsFailure(error));
	}
}

export function* resetSubmitEODDetailsResponse() {
	yield put(getSubmitEODDetailsResponseChanged());
}

export function* onGetSubmitEODDetails() {
	yield takeLatest(EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_START, getSubmitEODList);
}

export function* onGetSubmitEODDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_SUBMIT_EOD_DETAILS_RESPONSE_RESET,
		resetSubmitEODDetailsResponse,
	);
}
/** *********************  END GET EOD SUBMIT DETAILS ******************** */

/** *********************  START GET EOD REVERT DETAILS  ******************** */
export function* getRevertEODList({ payload }: any) {
	try {
		const key = 'GetRevertEODDetailsKey';
		const {
			companyID,
			branchID,
			databaseName,
			branchName,
			eodDate,
			eodAmount,
			userID,
			userName,
			infogCompanyID,
			totalPrincipalReceived,
			totalInterestReceived,
			bankOpeningBalance,
			bankClosingBalance,
			cashOpeningBalance,
			cashClosingBalance,
			twoThousandValue,
			fiveHundredValue,
			twoHundredValue,
			hundredValue,
			fiftyValue,
			twentyValue,
			tenValue,
			fiveValue,
			twoValue,
			oneValue,
			totalDenominationAmount,
			branchCashAccountID,
			branchBankAccountID,
			branchBankClosingBalance,
			closingBalanceIsDrCr,
			openingBalanceIsDrCr,
			bankOpeningBalanceIsDrCr,
			bankClosingBalanceIsDrCr,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			BranchName: branchName,
			EodDate: eodDate,
			EodAmount: eodAmount,
			UserID: userID,
			UserName: userName,
			CreatedBy: userID,
			InfogID: infogCompanyID,
			TotalPrincipalReceived: totalPrincipalReceived,
			TotalInterestReceived: totalInterestReceived,
			BankOpeningBalance: bankOpeningBalance,
			BankClosingBalance: bankClosingBalance,
			CashOpeningBalance: cashOpeningBalance,
			CashClosingBalance: cashClosingBalance,
			TwoThousandValue: twoThousandValue,
			FiveHundredValue: fiveHundredValue,
			TwoHundredValue: twoHundredValue,
			HundredValue: hundredValue,
			FiftyValue: fiftyValue,
			TwentyValue: twentyValue,
			TenValue: tenValue,
			FiveValue: fiveValue,
			TwoValue: twoValue,
			OneValue: oneValue,
			TotalDenominationAmount: totalDenominationAmount,
			BranchCashAccountID: branchCashAccountID,
			BranchBankAccountID: branchBankAccountID,
			BranchBankClosingBalance: branchBankClosingBalance,
			ClosingBalanceIsDrCr: closingBalanceIsDrCr,
			OpeningBalanceIsDrCr: openingBalanceIsDrCr,
			BankOpeningBalanceIsDrCr: bankOpeningBalanceIsDrCr,
			BankClosingBalanceIsDrCr: bankClosingBalanceIsDrCr,
			DatabaseName: databaseName,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(RevertEODDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getRevertEODDetailsFailure(responseData.data));
		} else {
			yield put(getRevertEODDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getRevertEODDetailsFailure(error));
	}
}

export function* resetRevertEODDetailsResponse() {
	yield put(getRevertEODDetailsResponseChanged());
}

export function* onGetRevertEODDetails() {
	yield takeLatest(EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_START, getRevertEODList);
}

export function* onGetRevertEODDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_REVERT_EOD_DETAILS_RESPONSE_RESET,
		resetRevertEODDetailsResponse,
	);
}
/** *********************  END GET EOD REVERT DETAILS ******************** */

/** *********************  START GET EOD SAVINGS COLLECTION DETAILS  ******************** */
export function* getEODSavingsCollectionList({ payload }: any) {
	try {
		const key = 'GetParticularDateSavingsDetailsKey';
		const { companyID, branchID, databaseName, eodDate } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			Date: eodDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(EODSavingsCollectionDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getEODSavingsCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getEODSavingsCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getEODSavingsCollectionDetailsFailure(error));
	}
}

export function* resetEODSavingsCollectionDetailsResponse() {
	yield put(getEODSavingsCollectionDetailsResponseChanged());
}

export function* onGetEODSavingsCollectionDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_START,
		getEODSavingsCollectionList,
	);
}

export function* onGetEODSavingsCollectionDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_EOD_SAVINGS_COLLECTION_DETAILS_RESPONSE_RESET,
		resetEODSavingsCollectionDetailsResponse,
	);
}
/** *********************  END GET EOD SAVINGS COLLECTION DETAILS ******************** */

/** *********************  START GET EOD GOLD COLLECTION DETAILS  ******************** */
export function* getEODGoldCollectionList({ payload }: any) {
	try {
		const key = 'GetGoldLoanCollectionEODDetailsKey';
		const { companyID, branchID, databaseName, eodDate } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: eodDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(EODGoldCollectionDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getEODGoldCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getEODGoldCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getEODGoldCollectionDetailsFailure(error));
	}
}
export function* resetEODGoldCollectionDetailsResponse() {
	yield put(getEODGoldCollectionDetailsResponseChanged());
}
export function* onGetEODGoldCollectionDetails() {
	yield takeLatest(
		EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_START,
		getEODGoldCollectionList,
	);
}
export function* onGetEODGoldCollectionDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_EOD_GOLD_COLLECTION_DETAILS_RESPONSE_RESET,
		resetEODGoldCollectionDetailsResponse,
	);
}
/** *********************  END GET EOD GOLD COLLECTION DETAILS ******************** */

/** *********************  START GET EOD STAFF TRAVEL DETAILS  ******************** */
export function* getEODStaffTravelList({ payload }: any) {
	try {
		const key = 'GetStaffTravelEODDetailsKey';
		const { companyID, branchID, databaseName, eodDate } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: eodDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(EODStaffTravelDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getEODStaffTravelDetailsFailure(responseData.data));
		} else {
			yield put(getEODStaffTravelDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getEODStaffTravelDetailsFailure(error));
	}
}

export function* resetEODStaffTravelDetailsResponse() {
	yield put(getEODStaffTravelDetailsResponseChanged());
}

export function* onGetEODStaffTravelDetails() {
	yield takeLatest(EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_START, getEODStaffTravelList);
}

export function* onGetEODStaffTravelDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_RESET,
		resetEODStaffTravelDetailsResponse,
	);
}
export const getEODStaffTravelDetailsResponseReset = () => {
	return {
		type: EndOfDayActionTypes.GET_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_RESET,
	};
};
/** *********************  END GET EOD STAFF TRAVEL DETAILS ******************** */

/** *********************  START SUBMIT EOD STAFF TRAVEL DETAILS  ******************** */
export function* submitEODStaffTravelList({ payload }: any) {
	try {
		const key = 'SubmitStaffTravelEODDetailsKey';
		const { companyID, branchID, databaseName, eodDate, staffTravel, userID, infogCompanyID } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: eodDate,
			StaffTravelDetails: staffTravel,
			CreatedBy: userID,
			InfogCompanyID: infogCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(SubmitEODStaffTravelDetailsPost, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(submitEODStaffTravelDetailsFailure(responseData.data));
		} else {
			yield put(submitEODStaffTravelDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(submitEODStaffTravelDetailsFailure(error));
	}
}

export function* resetSubmitEODStaffTravelDetailsResponse() {
	yield put(submitEODStaffTravelDetailsResponseChanged());
}

export function* onSubmitEODStaffTravelDetails() {
	yield takeLatest(
		EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_START,
		submitEODStaffTravelList,
	);
}

export function* onSubmitEODStaffTravelDetailsResponseReset() {
	yield takeLatest(
		EndOfDayActionTypes.SUBMIT_EOD_STAFF_TRAVEL_DETAILS_RESPONSE_RESET,
		resetSubmitEODStaffTravelDetailsResponse,
	);
}
/** *********************  END SUBMIT EOD STAFF TRAVEL DETAILS ******************** */

export function* EndOfDaySaga() {
	yield all([
		call(onGetAllCollectionDetails),
		call(onGetAllCollectionDetailsResponseReset),
		call(onGetBranchEODWalletDetails),
		call(onGetBranchEODWalletDetailsResponseReset),
		call(onGetBranchEODThriftDetails),
		call(onGetBranchEODThriftDetailsResponseReset),
		call(onGetBranchEODSavingsDetails),
		call(onGetBranchEODSavingsDetailsResponseReset),
		call(onGetBranchEODYetToCollectArrearDetails),
		call(onGetBranchEODYetToCollectArrearDetailsResponseReset),
		call(onGetDemandCollectionTotalDetails),
		call(onGetDemandCollectionTotalDetailsResponseReset),
		call(onGetAdvanceCollectionTotalDetails),
		call(onGetAdvanceCollectionTotalDetailsResponseReset),
		call(onGetArrearCollectionTotalDetails),
		call(onGetArrearCollectionTotalDetailsResponseReset),
		call(onGetWalletCollectionTotalDetails),
		call(onGetWalletCollectionTotalDetailsResponseReset),
		call(onGetPrecloseCollectionTotalDetails),
		call(onGetPrecloseCollectionTotalDetailsResponseReset),
		call(onGetLoanAdvanceUsedTotalDetails),
		call(onGetLoanAdvanceUsedTotalDetailsResponseReset),
		call(onGetCloseLoanListDetails),
		call(onGetCloseLoanListDetailsResponseReset),
		call(onGetBranchEODDetails),
		call(onGetBranchEODDetailsResponseReset),
		call(onGetPreviousDayBankAccountDayBookReportDetails),
		call(onGetPreviousDayBankAccountDayBookReportResponseReset),
		call(onGetAccountDayBookReportResponseReset),
		call(onGetAccountDayBookReportDetails),
		call(onGetPreviousDayCashAccountDayBookReportDetails),
		call(onGetPreviousDayCashAccountDayBookReportResponseReset),
		call(onGetCashAccountDayBookReportDetails),
		call(onGetCashAccountDayBookReportResponseReset),
		call(onGetPrecloseCollectionDetails),
		call(onGetPrecloseCollectionDetailsResponseReset),
		call(onGetAdvanceCollectionDetails),
		call(onGetAdvanceCollectionDetailsResponseReset),
		call(onGetArrearCollectionDetails),
		call(onGetArrearCollectionDetailsResponseReset),
		call(onGetVoucherApprovedDetails),
		call(onGetVoucherApprovedDetailsResponseReset),
		call(onGetSubmitEODDetails),
		call(onGetSubmitEODDetailsResponseReset),
		call(onGetRevertEODDetails),
		call(onGetRevertEODDetailsResponseReset),
		call(onGetBankAccountDayBookReportDetails),
		call(onGetBankAccountDayBookReportResponseReset),
		call(onGetEODSavingsCollectionDetails),
		call(onGetEODSavingsCollectionDetailsResponseReset),
		call(onGetEODGoldCollectionDetails),
		call(onGetEODGoldCollectionDetailsResponseReset),
		call(onGetEODStaffTravelDetails),
		call(onGetEODStaffTravelDetailsResponseReset),
		call(onSubmitEODStaffTravelDetails),
		call(onSubmitEODStaffTravelDetailsResponseReset),
	]);
}
